<template>
  <div>
    <v-progress-linear v-if="cargando" indeterminate color="purple" class="mb-2" />

    <ag-grid-vue
      :gridOptions="gridOptions"
      class="ag-theme-balham ag-grid-listado-programas-paginados"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      @grid-ready="onGridReady"
      :rowData="items"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="true"
      :pagination="false"
      :rowClassRules="rowClassRules"
      @selection-changed="onSelectionChanged"
      @first-data-rendered="onFirstDataRendered"
      :alwaysShowVerticalScroll="true"
      :suppressPaginationPanel="true">
    </ag-grid-vue>
  </div>
</template>
  
<script>
import { cellRendererSiONo } from '../../comisiones/utils/funciones';
import listadoAgGridMixin from '../mixins/listado-ag-grid.mixin';
import { cellRendererNumeroRegistro } from '../utils/funciones';
import BotonModulos from './BotonModulos.vue';

export default {
  name: 'ListadoProgramasPaginados',
  mixins: [listadoAgGridMixin],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BotonModulos,
  },
  props: {
    esListadoLargo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columnDefs: [
        {
          headerName: 'N° REGISTRO',
          cellRenderer: cellRendererNumeroRegistro,
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'ID',
          field: 'id',
          filter: true,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'CÓDIGO',
          cellRenderer: (params) => {
            const data = params.data;

            return data?.codigo ?? '-';
          },
          minWidth: 120,
          maxWidth: 120,
        },
        {
          headerName: 'SEDE',
          field: 'sede.nombre',
          minWidth: 180,
          maxWidth: 180,
        },
        {
          headerName: 'GESTIÓN',
          field: 'gestion',
          filter: false,
          minWidth: 80,
          maxWidth: 80,
        },
        {
          headerName: 'NOMBRE COMPUESTO',
          field: 'nombreCompuesto',
          minWidth: 550,
        },
        {
          headerName: 'REPORTADO',
          field: 'programaReportado',
          cellRenderer: cellRendererSiONo('programaReportado', 'SÍ', 'NO'),
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'MÓDULO ACTUAL',
          cellRenderer: 'BotonModulos',
          filter: true,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'CÓDIGO PROG. UNIV.',
          field: 'programaUniversidad.codigo',
          filter: true,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'PROGRAMA UNIVERSIDAD',
          field: 'programaUniversidad.programaNombre',
          minWidth: 400,
        },
        {
          headerName: 'VERSIÓN',
          field: 'version',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'GRUPO',
          field: 'grupo',
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'POSTGRADO',
          field: 'postgrado.nombre',
          minWidth: 400,
        },
      ],
    };
  },
};
</script>
  
<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';

.ag-grid-listado-programas-paginados {
  height: calc(var(--vh, 1vh) * 100 - 15rem);
}
</style>
  